import React from 'react';
import { Input as InputRS } from 'reactstrap';
import validator from 'validator';
import { Actions } from 'react-redux-grid';

export let legacyIdsColumns = [
	{
		name: 'System *',
		width: '60%',
		editable: false,
		className: 'additional-class',
		dataIndex: 'systemname',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _options = [
				<option key={-1} value="" disabled>
					Select system...
				</option>
			];
			(store.getState().config.platformNames || []).forEach((item, index) => {
				_options.push(<option key={index}>{item.platformId}</option>);
			});
			let _size = store.getState().dataSource.get('customerLegacyIds').get('data').size;
			return (
				<InputRS
					type="select"
					name="legacySystem"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsSysNameInput[rowId]) {
								window.legSysNameInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsSysNameInput[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsSysNameInput['row-' + _newRowIndex] = input;
							}
						}
					}}
					defaultValue=""
					value={value}
					placeholder="Select system..."
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					required
					onChange={handleChangeLegacySystem.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
				>
					{_options}
				</InputRS>
			);
		}
	},
	{
		name: 'Username *',
		width: '34%',
		editable: false,
		dataIndex: 'username',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerLegacyIds').get('data').size;
			return (
				<input
					name="legacyIdUserName"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsUserNameInput[rowId]) {
								window.legUserNameInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsUserNameInput[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsUserNameInput['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={20}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Username"
					onChange={handleChangeLegacyUserName.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	}
];

export let projectsColumns = [
	{
		name: 'Flow ID *',
		width: '20%',
		editable: false,
		className: 'additional-class',
		dataIndex: 'projectId',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerProjects').get('data').size;
			return (
				<input
					name="projectId"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsIdInputProj[rowId]) {
								window.projIdInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsIdInputProj[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsIdInputProj['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={20}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Project ID"
					onChange={handleChangeProjectID.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Name *',
		width: '20%',
		dataIndex: 'name',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerProjects').get('data').size;
			return (
				<input
					name="projectName"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsNameInputProj[rowId]) {
								window.projNameInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsNameInputProj[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsNameInputProj['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={50}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Name"
					onChange={handleChangeProjectName.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Description',
		width: '55%',
		dataIndex: 'description',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerProjects').get('data').size;
			return (
				<input
					name="projectDescription"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsDescInputProj[rowId]) {
								window.projDescInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsDescInputProj[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsDescInputProj['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={150}
					placeholder="Enter Description"
					onChange={handleChangeProjectDesc.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
				/>
			);
		}
	}
];

export let contactsColumns = [
	{
		name: 'Name, Surname *',
		width: '20%',
		editable: false,
		className: 'additional-class',
		dataIndex: 'Name',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerContacts').get('data').size;
			return (
				<input
					name="contactName"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsNameInputContact[rowId]) {
								window.contNameInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsNameInputContact[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsNameInputContact['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={50}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Name"
					onChange={handleChangeContactField.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Email *',
		width: '50%',
		editable: false,
		dataIndex: 'Email',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerContacts').get('data').size;
			return (
				<input
					name="contactEmail"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsEmailInputContact[rowId]) {
								window.contEmailInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsEmailInputContact[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsEmailInputContact['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={100}
					onBlur={handleEmailValidation.bind(null, rowId)}
					placeholder="Enter Email"
					onChange={handleChangeContactField.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Notes (phone, etc)',
		width: '30%',
		editable: false,
		dataIndex: 'Notes',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerContacts').get('data').size;
			return (
				<input
					name="contactNotes"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsNotesInputContact[rowId]) {
								window.contNotesInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsNotesInputContact[rowId] = input;
								}
							}
						} else {
							if (input && !!window.dummyLastRowsNotesInputContact) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsNotesInputContact['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={150}
					placeholder="Enter Contact Notes"
					onChange={handleChangeContactField.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
				/>
			);
		}
	}
];

export let sendersColumns = [
	{
		name: 'Sender ID *',
		width: '20%',
		editable: false,
		className: 'additional-class',
		dataIndex: 'senderId',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerSenders').get('data').size;
			return (
				<input
					name="senderId"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsIdInputSender[rowId]) {
								window.senderIdInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsIdInputSender[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsIdInputSender['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={20}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Sender ID"
					onChange={handleChangeSenderID.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Company Name *',
		width: '30%',
		dataIndex: 'senderCompanyName',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerSenders').get('data').size;
			return (
				<input
					name="senderCompanyName"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsCompanyNameInputSender[rowId]) {
								window.senderCompanyNameInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsCompanyNameInputSender[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsCompanyNameInputSender['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={30}
					onBlur={handleRequiredFieldValidation.bind(null, rowId)}
					placeholder="Enter Company Name"
					onChange={handleChangeSenderCompanyName.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
					required
				/>
			);
		}
	},
	{
		name: 'Customer Code',
		width: '45%',
		dataIndex: 'customerCode',
		className: 'additional-class',
		editor: ({ column, columns, value, stateKey, store, rowId }) => {
			let _size = store.getState().dataSource.get('customerSenders').get('data').size;
			return (
				<input
					name="customerCode"
					ref={(input) => {
						if (rowId !== undefined && value !== undefined) {
							if (!window.dummyLastRowsCustomerCodeInputSender[rowId]) {
								window.senderCustomerCodeInputRefList[rowId] = input;
							} else {
								if (input) {
									window.dummyLastRowsCustomerCodeInputSender[rowId] = input;
								}
							}
						} else {
							if (input) {
								let _newRowIndex = _size - 1;
								window.dummyLastRowsCustomerCodeInputSender['row-' + _newRowIndex] = input;
							}
						}
					}}
					className="form-control"
					value={value}
					maxLength={150}
					placeholder="Enter Customer Code"
					onChange={handleChangeSenderCustomerCode.bind(null, {
						store,
						stateKey,
						column,
						columns,
						rowId
					})}
				/>
			);
		}
	}
];

export function handleEmailValidation(rowId, e) {
	if (rowId !== undefined && rowId.startsWith('row-')) {
		let _input = e.target;
		if(!_input) return;
		if (validator.isEmail(_input.value)) {
			_input.style.borderColor = '';
		} else {
			_input.style.borderColor = '#e74c3c';
		}
	}
}

export function handleRequiredFieldValidation(rowId, e) {
	if (rowId !== undefined && rowId.startsWith('row-')) {
		let _input = e.target;
		if(!_input) return;
		if (_input?.value && _input.value.toString().trim().length) {
			_input.style.borderColor = '';
		} else {
			_input.style.borderColor = '#e74c3c';
		}
	}
}

function handleChangeContactField({ store, stateKey, column, columns, rowId }, e) {
	let _list = store.getState().dataSource.get('customerContacts').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	_list[rowIndex][column.dataIndex] = e.target.value;
	let values = Object.assign({}, _list[rowIndex]);
	let _size = store.getState().dataSource.get('customerContacts').get('data').size;
	//let values = Object.assign(_list[rowIndex], {Email: e.target.value});
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	let _dummyArr = null;
	if (column.dataIndex === 'Name') {
		_dummyArr = window.dummyLastRowsNameInputContact;
	} else if (column.dataIndex === 'Email') {
		_dummyArr = window.dummyLastRowsEmailInputContact;
	} else {
		_dummyArr = window.dummyLastRowsNotesInputContact;
	}

	if (!rowId || (!_rowValues.Name && !_rowValues.Email && !_rowValues.Notes && !rowId.startsWith('row-'))) {
		let columns = contactsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custContacts = (store.getState().dataSource.get('customerContacts').get('data').toJS() || [])
			.map((item, index) => {
				return {
					Name: item.Name,
					Email: item.Email,
					Notes: item.Notes
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerContacts',
				data: custContacts,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerContacts',
				rowIndex: rowIndex + 1,
				rowData: {
					Name: '',
					Email: '',
					Notes: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (_dummyArr[_origRowIndex]) {
				_dummyArr[_origRowIndex].focus();
				_dummyArr[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!_dummyArr[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeProjectID({ store, stateKey, column, columns, rowId }, e) {
	//const target = selectedItem.value;
	let _list = store.getState().dataSource.get('customerProjects').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { projectId: e.target.value });
	let _size = store.getState().dataSource.get('customerProjects').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (!rowId || (!_rowValues.projectId && !_rowValues.name && !_rowValues.description && !rowId.startsWith('row-'))) {
		let columns = projectsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custProjects = (store.getState().dataSource.get('customerProjects').get('data').toJS() || [])
			.map((item, index) => {
				return {
					projectId: item.projectId,
					name: item.name,
					description: item.description
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerProjects',
				data: custProjects,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerProjects',
				rowIndex: rowIndex + 1,
				rowData: {
					projectId: '',
					name: '',
					description: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsIdInputProj[_origRowIndex]) {
				window.dummyLastRowsIdInputProj[_origRowIndex].focus();
				window.dummyLastRowsIdInputProj[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsIdInputProj[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeProjectName({ store, stateKey, column, columns, rowId }, e) {
	//const target = selectedItem.value;
	let _list = store.getState().dataSource.get('customerProjects').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { name: e.target.value });
	let _size = store.getState().dataSource.get('customerProjects').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (!rowId || (!_rowValues.projectId && !_rowValues.name && !_rowValues.description && !rowId.startsWith('row-'))) {
		let columns = projectsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custProjects = (store.getState().dataSource.get('customerProjects').get('data').toJS() || [])
			.map((item, index) => {
				return {
					projectId: item.projectId,
					name: item.name,
					description: item.description
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerProjects',
				data: custProjects,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerProjects',
				rowIndex: rowIndex + 1,
				rowData: {
					projectId: '',
					name: '',
					description: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsNameInputProj[_origRowIndex]) {
				window.dummyLastRowsNameInputProj[_origRowIndex].focus();
				window.dummyLastRowsNameInputProj[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsNameInputProj[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeProjectDesc({ store, stateKey, column, columns, rowId }, e) {
	let _list = store.getState().dataSource.get('customerProjects').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { description: e.target.value });
	let _size = store.getState().dataSource.get('customerProjects').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (!rowId || (!_rowValues.projectId && !_rowValues.name && !_rowValues.description && !rowId.startsWith('row-'))) {
		let columns = projectsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custProjects = (store.getState().dataSource.get('customerProjects').get('data').toJS() || [])
			.map((item, index) => {
				return {
					projectId: item.projectId,
					name: item.name,
					description: item.description
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerProjects',
				data: custProjects,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerProjects',
				rowIndex: rowIndex + 1,
				rowData: {
					projectId: '',
					name: '',
					description: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsDescInputProj[_origRowIndex]) {
				window.dummyLastRowsDescInputProj[_origRowIndex].focus();
				window.dummyLastRowsDescInputProj[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsDescInputProj[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeLegacyUserName({ store, stateKey, column, columns, rowId }, e) {
	let _list = store.getState().dataSource.get('customerLegacyIds').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { username: e.target.value });
	let _size = store.getState().dataSource.get('customerLegacyIds').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (!rowId || (!_rowValues.systemname && !_rowValues.username && !rowId.startsWith('row-'))) {
		let columns = legacyIdsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custLegacyIds = (store.getState().dataSource.get('customerLegacyIds').get('data').toJS() || [])
			.map((item, index) => {
				return {
					systemname: item.systemname,
					username: item.username
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerLegacyIds',
				data: custLegacyIds,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerLegacyIds',
				rowIndex: rowIndex + 1,
				rowData: {
					systemname: '',
					username: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsUserNameInput[_origRowIndex]) {
				window.dummyLastRowsUserNameInput[_origRowIndex].focus();
				window.dummyLastRowsUserNameInput[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else {
		if (!window.dummyLastRowsUserNameInput[rowId]) {
			return store.dispatch(
				Actions.EditorActions.updateCellValue({
					column,
					columns,
					name: column.dataIndex,
					rowId,
					stateKey,
					value: e.target.value
				})
			);
		}
	}
}

function handleChangeLegacySystem({ store, stateKey, column, columns, rowId }, selectedItem) {
	const _selectedValue = selectedItem.target.value;
	let _list = store.getState().dataSource.get('customerLegacyIds').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { systemname: _selectedValue });
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);
	if (rowId === undefined || (!_rowValues.systemname && !_rowValues.username)) {
		let columns = legacyIdsColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custLegacyIds = (store.getState().dataSource.get('customerLegacyIds').get('data').toJS() || [])
			.map((item, index) => {
				return {
					systemname: item.systemname,
					username: item.username
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerLegacyIds',
				data: custLegacyIds,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerLegacyIds',
				rowIndex: rowIndex + 1,
				rowData: {
					systemname: '',
					username: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
	}

	return store.dispatch(
		Actions.EditorActions.updateCellValue({
			column,
			columns,
			name: column.dataIndex,
			rowId,
			stateKey,
			value: _selectedValue
		})
	);
}

function handleChangeSenderID({ store, stateKey, column, columns, rowId }, e) {
	//const target = selectedItem.value;
	let _list = store.getState().dataSource.get('customerSenders').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { senderId: e.target.value });
	let _size = store.getState().dataSource.get('customerSenders').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (
		!rowId ||
		(!_rowValues.senderId && !_rowValues.senderCompanyName && !_rowValues.customerCode && !rowId.startsWith('row-'))
	) {
		let columns = sendersColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custSenders = (store.getState().dataSource.get('customerSenders').get('data').toJS() || [])
			.map((item, index) => {
				return {
					senderId: item.senderId,
					senderCompanyName: item.senderCompanyName,
					customerCode: item.customerCode
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerSenders',
				data: custSenders,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerSenders',
				rowIndex: rowIndex + 1,
				rowData: {
					senderId: '',
					senderCompanyName: '',
					customerCode: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsIdInputSender[_origRowIndex]) {
				window.dummyLastRowsIdInputSender[_origRowIndex].focus();
				window.dummyLastRowsIdInputSender[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsIdInputSender[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeSenderCompanyName({ store, stateKey, column, columns, rowId }, e) {
	//const target = selectedItem.value;
	let _list = store.getState().dataSource.get('customerSenders').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], {
		senderCompanyName: e.target.value
	});
	let _size = store.getState().dataSource.get('customerSenders').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (
		!rowId ||
		(!_rowValues.senderId && !_rowValues.senderCompanyName && !_rowValues.customerCode && !rowId.startsWith('row-'))
	) {
		let columns = sendersColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custSenders = (store.getState().dataSource.get('customerSenders').get('data').toJS() || [])
			.map((item, index) => {
				return {
					senderId: item.senderId,
					senderCompanyName: item.senderCompanyName,
					customerCode: item.customerCode
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerSenders',
				data: custSenders,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerSenders',
				rowIndex: rowIndex + 1,
				rowData: {
					senderId: '',
					senderCompanyName: '',
					customerCode: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsCompanyNameInputSender[_origRowIndex]) {
				window.dummyLastRowsCompanyNameInputSender[_origRowIndex].focus();
				window.dummyLastRowsCompanyNameInputSender[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsCompanyNameInputSender[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}

function handleChangeSenderCustomerCode({ store, stateKey, column, columns, rowId }, e) {
	let _list = store.getState().dataSource.get('customerSenders').get('data').toJS() || [];
	let rowIndex = _list
		.map(function(e) {
			return e._key;
		})
		.indexOf(rowId);
	let _rowValues = Object.assign({}, _list[rowIndex]);
	let values = Object.assign(_list[rowIndex], { customerCode: e.target.value });
	let _size = store.getState().dataSource.get('customerSenders').get('data').size;
	store.dispatch(
		Actions.EditorActions.saveRow({
			values,
			stateKey,
			rowIndex
		})
	);

	if (
		!rowId ||
		(!_rowValues.senderId && !_rowValues.senderCompanyName && !_rowValues.customerCode && !rowId.startsWith('row-'))
	) {
		let columns = sendersColumns.map((item) => {
			if (item.name === '') {
				return { ...item, hidden: false };
			} else {
				return { ...item, editable: true };
			}
		});

		// insert new row
		let custSenders = (store.getState().dataSource.get('customerSenders').get('data').toJS() || [])
			.map((item, index) => {
				return {
					senderId: item.senderId,
					senderCompanyName: item.senderCompanyName,
					customerCode: item.customerCode
				};
			});
		store.dispatch(
			Actions.GridActions.setData({
				stateKey: 'customerSenders',
				data: custSenders,
				editMode: false
			})
		);
		store.dispatch(
			Actions.EditorActions.addNewRow({
				stateKey: 'customerSenders',
				rowIndex: rowIndex + 1,
				rowData: {
					senderId: '',
					senderCompanyName: '',
					customerCode: ''
				},
				columns,
				editMode: true,
				isCreate: true
			})
		);
		setTimeout(function() {
			let _origRowIndex = 'row-' + (_size - 1);
			if (window.dummyLastRowsCustomerCodeInputSender[_origRowIndex]) {
				window.dummyLastRowsCustomerCodeInputSender[_origRowIndex].focus();
				window.dummyLastRowsCustomerCodeInputSender[_origRowIndex].setSelectionRange(1, 1);
			}
		}, 50);
	} else if (!window.dummyLastRowsCustomerCodeInputSender[rowId]) {
		return store.dispatch(
			Actions.EditorActions.updateCellValue({
				column,
				columns,
				name: column.dataIndex,
				rowId,
				stateKey,
				value: e.target.value
			})
		);
	}
}
